import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface NotificationState {
  notifications: Number;
}

const initialState: NotificationState = {
  notifications: 0,
};

const notificationsSlice = createSlice({
  name: 'notificationCount',
  initialState,
  reducers: {
    updateNotification: (state, action: PayloadAction<Number>) => {
    //   state.notifications.push(action.payload);
    state.notifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { updateNotification} = notificationsSlice.actions;
export default notificationsSlice.reducer;
